import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {User} from "./User";
import {Injectable} from "@angular/core";
import {ProjectService} from "../../store/base/project.service";

@Injectable({ providedIn: 'root' })
export class UserService {
  private apiV1: string = environment.apiV1;
  private baseRef: string = environment.origin;
  private serviceRef: string = environment.service.user;

  constructor(
    private httpClient: HttpClient,
    private projectService: ProjectService
  ) { }

  public getOne(userId: string): Observable<User> {
    return this.httpClient.get<User>(`${this.baseRef}${this.serviceRef}${this.apiV1}users/${userId}`);
  }

  public getMe(externalId: string): Observable<User> {
    const encoded: string = encodeURIComponent(externalId);
    return this.httpClient.get<User>(`${this.baseRef}${this.serviceRef}${this.apiV1}users/me/${encoded}`);
  }

  public getAll(): Observable<User[]> {
    return this.httpClient.get<User[]>(`${this.baseRef}${this.serviceRef}${this.apiV1}users`);
  }

  public createOne(user: User) {
    return this.httpClient.post<User>(`${this.baseRef}${this.serviceRef}${this.apiV1}users`, user)
      .subscribe((newUser: User) => this.projectService.upsertUser(newUser));
  }

  public updateOne(userId: string, user: User) {
    return this.httpClient.put<User>(`${this.baseRef}${this.serviceRef}${this.apiV1}users/${userId}`, user)
      .subscribe((newUser: User) => this.projectService.upsertUser(newUser));
  }

  public async deleteOne(userId: string): Promise<boolean> {
    return new Promise<boolean>(((resolve) => {
      return this.httpClient.delete<void>(`${this.baseRef}${this.serviceRef}${this.apiV1}users/${userId}`)
        .subscribe(() => {
          this.projectService.deleteUser(userId)
          resolve(true);
        });
    }));
  }

}
